// MUST be first import - configures logging before other modules load
import "./logging-config";

import { captureException, init, setTags } from "@sentry/react";
import { createRoot } from "react-dom/client";
import "./index.css";
import Root from "./Root";
import theme from "./theme.ts";
import { initErrorReporting } from "./utils/errorReporting";

import { CssBaseline, ThemeProvider } from "@mui/material";

console.log(`[orgiggly] build ${__BUILD_COMMIT__} (${__BUILD_TIMESTAMP__})`);

// Install client error reporting before render so the global error /
// unhandledrejection handlers are armed as early as possible. The @sentry/react
// SDK is imported only here (named imports, so Rollup tree-shakes the unused
// replay/feedback integrations) and injected into the singleton; a "" DSN (dev /
// E2E / non-prod build, see vite.config) makes init() a no-op.
initErrorReporting(
  { init, captureException, setTags },
  {
    dsn: __SENTRY_DSN__,
    release: __BUILD_COMMIT__,
    environment: import.meta.env.MODE,
  },
);

createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme}>
    <CssBaseline /> {/* resets & dark-mode aware */}
    <Root />
  </ThemeProvider>
);
